import { z } from 'zod';
export const knowledgeImportCapability = 'knowledge.import-reconciliation.v1';
export const knowledgeImportManifestVersion = 'knowledge-source-manifest.v1';
export const knowledgeImportMappingVersion = 'knowledge-import-v1';
export const knowledgeImportEntityTypeSchema = z.enum([
    'collection',
    'document',
    'document-version',
    'collection-access-rule',
    'document-access-rule',
    'review-assignment',
    'review-decision',
    'acknowledgement',
]);
export const knowledgeImportCountsByEntitySchema = z.strictObject({
    collection: z.number().int().nonnegative().safe(),
    document: z.number().int().nonnegative().safe(),
    'document-version': z.number().int().nonnegative().safe(),
    'collection-access-rule': z.number().int().nonnegative().safe(),
    'document-access-rule': z.number().int().nonnegative().safe(),
    'review-assignment': z.number().int().nonnegative().safe(),
    'review-decision': z.number().int().nonnegative().safe(),
    acknowledgement: z.number().int().nonnegative().safe(),
});
export const knowledgeImportDomainTotalsSchema = z.strictObject({
    collectionCount: z.number().int().nonnegative().safe(),
    archivedCollectionCount: z.number().int().nonnegative().safe(),
    documentCount: z.number().int().nonnegative().safe(),
    publishedDocumentCount: z.number().int().nonnegative().safe(),
    archivedDocumentCount: z.number().int().nonnegative().safe(),
    versionCount: z.number().int().nonnegative().safe(),
    acknowledgementRequiredVersionCount: z.number().int().nonnegative().safe(),
    collectionAccessRuleCount: z.number().int().nonnegative().safe(),
    documentAccessRuleCount: z.number().int().nonnegative().safe(),
    reviewAssignmentCount: z.number().int().nonnegative().safe(),
    pendingReviewAssignmentCount: z.number().int().nonnegative().safe(),
    reviewDecisionCount: z.number().int().nonnegative().safe(),
    approvedReviewDecisionCount: z.number().int().nonnegative().safe(),
    acknowledgementCount: z.number().int().nonnegative().safe(),
});
export const knowledgeImportRunSummarySchema = z.strictObject({
    runId: z.string().uuid(),
    sourceSha256: z.string().regex(/^[a-f0-9]{64}$/),
    planSha256: z.string().regex(/^[a-f0-9]{64}$/),
    targetSha256: z.string().regex(/^[a-f0-9]{64}$/),
    sourceRows: z.number().int().nonnegative().safe(),
    plannedRows: z.number().int().nonnegative().safe(),
    appliedRows: z.number().int().nonnegative().safe(),
    skippedRows: z.number().int().nonnegative().safe(),
    verifiedRows: z.number().int().nonnegative().safe(),
    rejectedRows: z.number().int().nonnegative().safe(),
    countsByEntity: knowledgeImportCountsByEntitySchema,
    domainTotals: knowledgeImportDomainTotalsSchema,
    result: z.literal('pass'),
});
//# sourceMappingURL=knowledge-import.contract.js.map